module.exports = __webpack_public_path__ + "img/dose-graph-mobile-noicon.0c76b4a3.png";